/**
 *
 *
 * @param {Array} type 多语言类型，默认input

 * @class LanguageInput
 * @extends {Component}
 */
export const defaulProps = function () {
  return {
    type: "input",
  };
};



// WEBPACK FOOTER //
// ./src/yx-widget/component/MultipleInput/params.js